import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHeaderInterceptor } from './auth-interceptor';
import { ErrorResponceInterceptor } from './error-interceptor';

export const HttpInterceptProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthHeaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorResponceInterceptor, multi: true }
];
